import React, {FC, ReactNode} from "react";

export const ModerationHint: FC<{ children: ReactNode, className?: string }> = ({children, className}) => <div
    className={`alert alert-dismissible ${className ?? 'mt-3 alert-danger '}`}>
    {children}
</div>